import { User } from 'types';

export const getAssigneeInitials = (assignee?: User) =>
  assignee?.firstName && assignee?.lastName
    ? `${assignee.firstName[0]}${assignee.lastName[0]}`.toUpperCase()
    : '';
